import { Logo } from '@/components/decoration/Logo';
import { ImagePreloader } from '@/components/image/ImagePreloader';
import { RoleType, useRole } from '@/services/authentication/hooks/user';
import clsx from 'clsx';
import { FC, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { AdminLandingPage } from './AdminLandingPage';
import { CustomerLandingPage } from './CustomerLandingPage';

export const LandingPage: FC = () => {
  useEffect(() => {
    if (role.type === RoleType.CreditChecker) {
      navigate('/creditcheck');
    }
  }, []);

  const role = useRole();
  const navigate = useNavigate();

  const headerBackgroundImageUrl = 'https://daasportal.app/wp-content/uploads/2023/06/DaaS-Device-As-A-Service.webp';

  const imageHeightClass = useMemo(() => {
    if (role.type === RoleType.Company) {
      return 'h-[32rem]';
    } else if (role.type === RoleType.Partner) {
      return 'h-[calc(100vh-60px)]';
    }

    return 'h-60';
  }, [role]);

  return (
    <div className="overflow-auto">
      <ImagePreloader url={headerBackgroundImageUrl} />
      <div className="">
        <div
          style={{ backgroundImage: `url(${headerBackgroundImageUrl})` }}
          className={clsx('w-full bg-cover py-10 bg-center flex items-center', imageHeightClass)}
        >
          <div className="w-[500px] mx-auto h-[10rem] bg-[rgba(238,238,238,0.8)] rounded-lg p-8">
            <Logo className="h-full mx-auto" />
          </div>
        </div>
      </div>
      {role.type === RoleType.Company && <CustomerLandingPage />}
      {role.type === RoleType.Admin && <AdminLandingPage />}
    </div>
  );
};
